<template>
    <div id="NoticeRule">
        <p class="view-title" v-show="!addRuleShow && !editRuleShow">通知规则</p>
        <div v-show="!addRuleShow && !editRuleShow" class="organize">
            <organize @setOrId="setOrId(arguments)" :recoveryName="recoveryName" @setTree="setTree"></organize>
        </div>
        <!-- 列表 -->
        <div class="list-box" v-show="!addRuleShow && !editRuleShow" style="top: 77px;">
            <header class="tabs-box clearfix">
                <div :class="{'active':state==0}" @click="headClick(0)" id="headClick0"><span>全部</span></div>
                <div :class="{'active':state==1}" @click="headClick(1)" id="headClick1"><span>启用</span></div>
                <div :class="{'active':state==2}" @click="headClick(2)" id="headClick2"><span>停用</span></div>
                <div :class="{'active':state==3}" @click="headClick(3)" id="headClick3"><span>通用</span></div>
                <div :class="{'active':state==4}" @click="headClick(4)" id="headClick4"><span>自定义</span></div>
            </header>
            <div class="bg">
                <div class="list-top clearfix">
                    <el-button type="primary" class="add-btn" @click="addRule" id="addRuleBtn" :disabled="!functionSet.includes('noticeRuleEdit')||$store.state.isLook">新建规则</el-button>
                    <div class="search-btn">
                        <el-button type="primary" class="add-btn" @click="search" id="searchBtn">搜索</el-button>
                    </div>
                    <div class="search">
                        <el-input
                            placeholder="请输入规则名称"
                            v-model="searchVal" class="search-input" id="searchRuleVal" @keyup.enter.native="search">
                            <i slot="suffix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </div>
                </div>
                <div class="company-list clearfix">
                    <ul class="list-title">
                        <li>规则名称</li>
                        <li class="w-18">规则类型</li>
                        <li>规则状态</li>
                        <li class="w-18">备注</li>
                        <li class="min-120">操作</li>
                    </ul>
                    <div class="scroll">
                        <ul class="list-details" v-for="(item,i) in dataList" :key="i" v-show="dataList.length!=0 && i<pageSize">
                            <li :title="item.name"><i class="typeicon"><img :src="item.type==1?rule1:rule"></i>{{item.name}}</li>
                            <li class="w-18" >{{item.type==1?"通用":"自定义"}}规则</li>
                            <li :class="{'color-red':item.state != 1}">{{item.state==1?"启用":"停用"}}</li>
                            <li class="w-18" :title="item.note">{{item.note}}</li>
                            <li class="operate min-120">
                                <span @click="operate(item,'editRuleShow',i)" :id="`editRule${i}`">{{changeBtn(item)&&!$store.state.isLook?'编辑':'查看'}}</span>
                                <span :class="{'disabled':!changeBtn(item)||$store.state.isLook}" @click="operate(item,'delRuleShow',i)" :id="`delRule${i}`">删除</span>
                                <span :class="{'disabled':!changeBtn(item)||$store.state.isLook}" @click="operate(item,'enableRuleShow',i)" :id="`enableRule${i}`" v-show="item.state!=1">启用</span>
                                <span :class="{'disabled':!changeBtn(item)||$store.state.isLook}" @click="operate(item,'disableRuleShow',i)" :id="`disableRule${i}`" v-show="item.state==1">停用</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 没有列表数据 -->
                <div class="nullDataBox" v-show="dataList.length==0">
                    <img :src="nullData" class="nullData">
                    <span>什么东西都没有找到...</span>
                </div>
            </div>
            <!-- 分页 -->
            <Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber"></Pagination>
            <!-- 弹窗 -->
            <div class="popup">
                <!-- 删除通知规则 -->
                <div class="popup-delAlarm" v-show="delRuleShow">
                    <div class="popup-title">
                        删除通知规则<i class="el-icon-circle-close close" @click="close('delRuleShow')" id="closeDel1"></i>
                    </div>
                    <div class="popup-lab t-left">
                        系统将删除该通知规则"{{nowObj.name}}",是否继续？
                        <p class="popup-btn-box"><el-button type="primary" :disabled="!functionSet.includes('noticeRuleEdit')" id="delRule" @click="delNoticeRule">确定</el-button> <el-button @click="close('delRuleShow')" id="closeDel2">取消</el-button></p>
                    </div>
                </div>
                <!-- 启用通知规则 -->
                <div class="popup-delAlarm" v-show="enableRuleShow">
                    <div class="popup-title">
                        启用通知规则<i class="el-icon-circle-close close" @click="close('enableRuleShow')" id="closeEnable1"></i>
                    </div>
                    <div class="popup-lab t-left">
                        系统将启用该通知规则"{{nowObj.name}}",是否继续？
                        <p class="popup-btn-box"><el-button type="primary" :disabled="!functionSet.includes('noticeRuleEdit')" id="enableRule" @click="enaNoticeRule">确定</el-button> <el-button @click="close('enableRuleShow')" id="closeEnable12">取消</el-button></p>
                    </div>
                </div>
                <!-- 停用通知规则 -->
                <div class="popup-delAlarm" v-show="disableRuleShow">
                    <div class="popup-title">
                        停用通知规则<i class="el-icon-circle-close close" @click="close('disableRuleShow')" id="closeDisable1"></i>
                    </div>
                    <div class="popup-lab t-left">
                        系统将停用该通知规则"{{nowObj.name}}",是否继续？
                        <p class="popup-btn-box"><el-button type="primary" :disabled="!functionSet.includes('noticeRuleEdit')" id="disableRule" @click="disNoticeRule">确定</el-button> <el-button @click="close('disableRuleShow')" id="closeDisable2">取消</el-button></p>
                    </div>
                </div>
                <!-- 验证码授权 -->
                <div class="popup-clear" v-show='functionShow' id="privilege" style="height: 349px;text-align: left;margin-left: -40%">
                    <div class="popup-title">
                        获取验证码授权<i><img :src="notes" title="提示" class="notes"></i><i class="el-icon-circle-close close" @click="close('functionShow')" id="closeClear3"></i>
                    </div>
                    <div class="popup-lab">
                        手机号：
                        <el-input disabled v-model="phone">{{phone}}</el-input>
                    </div>
                    <div class="popup-lab clearfix">
                        <p style="position: relative; left: -11px;"><i class="star">*</i>验证码：</p>
                        <el-form style="float: left; width: 255px;" :model="verifyForm" :rules="rules" ref="verifyCode" @submit.native.prevent>
                            <el-form-item prop="verifyCode">
                                <el-input id="verifyCode2" class="verifyCode" placeholder="请输入4位验证码" @keyup.enter.native="Privilege" v-model='verifyForm.verifyCode' maxlength="4" @input="verifyForm.verifyCode=verifyForm.verifyCode.replace(/[^\d]/g, '')"></el-input>
                            </el-form-item>
                        </el-form>
                        <div class="code-box">
                            <p class="get-code" v-show="getCodeShow" @click.stop='getCode' id="getCodeBtn2">获取验证码</p>
                            <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
                        </div>
                    </div>
                    <div class="popup-lab">
                        <p class="btn-box">
                            <el-button type="primary" @click="Privilege" id="toClear2">确定</el-button>
                            <el-button @click="close('functionShow')" id="closeClear4">取消</el-button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="popup">
            <!-- 添加角色 -->
            <div class="popup-role" v-show="roleShow">
                <div class="popup-title">
                    通知对象
                    <div class="content-box">
                        <div class="roleTree tree p-l-0">
                            <p class="roleTree-top">可选</p>
                            <div class="tree-box">
                                <el-tree :indent='0' ref="noticeTree" :data="noticeTree" node-key="code" :expand-on-click-node="false" :show-checkbox="true" :check-strictly="true" :props="defaultProps" :default-expand-all="true" @check-change="handleCheckChange">
                                    <span class="custom-tree-node" slot-scope="{ node, data }">
                                        <i><img :src="data.type == 1 ? branch : data.type == 2 ? jczu :data.type == 3 ? qyzu:user" class="tree-icon"></i>
                                        <span>{{ node.label }} <span v-if='node.level==1&&data.roleName'>({{data.roleName}})</span></span>
                                        </span>
                                    </span>
                                </el-tree>
                            </div>
                        </div>
                        <div class="role-selected">
                            <p class="roleTree-top">已选</p>
                            <div class="addrole-list">
                                <p v-for="addRole,a in addRoleList" @mouseover="delCode = addRole.id" :tabindex="addRole.id" class="c-pointer del-option"> <!--:class="[{ 'currency': addRole.type == 1 },'c-pointer','del-option']" -->
                                    <i><img :src="addRole.type == 1 ? branch : addRole.type == 2 ? jczu :addRole.type == 3 ? qyzu:user" class="role-icon"></i>
                                    {{addRole.name}}<span v-show="addRole.groupName">/{{addRole.groupName}}</span>
                                    <i v-show="addRole.id == delCode"><img :src="delIcon" title='删除' class="add-icon del-icon" @click="delRole(addRole,a)" :id="`delRoleList${a}`"></i>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="btn-box"><el-button type="primary" @click="editRole" id="yesEditRole">确定</el-button> <el-button @click="closeRole" id="noEditRole">取消</el-button></p>
            </div>

        </div>
        <!-- 通知规则 -->
        <div class="rule-box clearfix" v-if="addRuleShow || editRuleShow">
            <p class="breadcrumb" v-show="addRuleShow"><span class="c-pointer" @click="toList" id="toList">通知规则</span><i><img :src="right" class="right"></i><span>新建通知规则</span></p>
            <p class="breadcrumb" v-show="editRuleShow"><span class="c-pointer" @click="toList" id="toList">通知规则</span><i><img :src="right" class="right"></i><span >{{changeBtn(nowObj)&&!$store.state.isLook?"编辑":'查看'}}通知规则</span></p>
            <el-form :model="ruleForm" @validate="changeForm" :rules="rules" ref="addAlarm" class="clearfix" :disabled="editRuleShow&&!changeBtn(nowObj)||$store.state.isLook" style="height: 88%;">
                <div class="rule-box-left">
                    <el-form-item label="规则名称：" autocomplete="off" prop="name">
                        <i class="f-l"><img :src="notes" title="须介于1~32个字符之间，支持中文、大小写字母、数字、短划线、下划线和小数点，必须以中文、英文或数字开头" class="notes"></i>
                        <el-input v-model="ruleForm.name" placeholder="请输入您的规则名称"></el-input>
                    </el-form-item>
                    <el-form-item label="规则类型：" autocomplete="off" prop="type" class="m-b-0">
                        <el-radio-group v-model="ruleForm.type" class="m-l-12">
                            <el-radio :label="2">自定义规则</el-radio>
                            <el-radio :label="1" :disabled="!functionSet.includes('noticeRuleNormal')">通用规则</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="所属组织：" autocomplete="off" class="m-b-0">
                        <i class="f-l"><img :src="notes" title="" class="notes"></i>
                        <div class="popup-lab m-t-0">
                            <div class="or-Superior" @click='showSelect' @mouseleave="selectShow=false" v-show="ruleForm.type==2&&functionSet.includes('noticeRuleEdit')">
                                {{orSuperior.name}}
                                <i><img :src="down" @click="showSelect"></i>
                                <div class="select-box tree" ref="selectbox" v-show='selectShow'>
                                    <div class="dashed">
                                        <el-tree :data="orSuperiorData" :indent='0' ref='Ntree' node-key="code" :highlight-current="true" :default-expand-all="true" :check-on-click-node="false" @node-click="selectId" :props="defaultProps">
                                            <span class="custom-tree-node" slot-scope="{ node, data }">
                                                <i><img :src="data.type == 1 ? branch : data.type == 2 ? jczu : qyzu" class="tree-icon"></i>
                                                <span>{{ node.label }} <span v-if='data.roleName&&data.type!=3'>({{data.roleName}})</span></span>
                                            </span>
                                        </el-tree>
                                    </div>
                                </div>
                            </div>
                            <div class="or-Superior disabled3" v-show="ruleForm.type==1||!functionSet.includes('noticeRuleEdit')">
                                <span v-show='ruleForm.type!=1'>{{orSuperior.name}}</span>
                                <i><img :src="down"></i>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="通知对象：" autocomplete="off" prop="">
                        <i class="f-l edit-noticeObj" @click="showRole"><img :src="this.cssType==0?edit0:edit1" class="notes" style="width: 20px;">编辑</i>
                        <div class="noticeObj-box">
                            <p class="role-list" v-for="role in oldRoleList">
                                <!-- <span v-if="role.type==1">{{role.name}}(通用)</span> -->
                                <span>{{role.name}}<span v-show="role.groupName">/{{role.groupName}}</span></span>
                            </p>
                        </div>
                    </el-form-item>
                    <el-form-item label="通知时段：" autocomplete="off" prop="timeType">
                        <el-radio-group v-model="ruleForm.rule.timeType" class="m-l-12">
                            <el-radio :label="1">所有时间</el-radio>
                            <el-radio :label="2">指定时间</el-radio>
                        </el-radio-group>
                        <div>
                            <el-checkbox-group v-model="ruleForm.rule.week" class="weekList" :disabled='ruleForm.rule.timeType == 1'>
                                <el-checkbox :label="2">周一</el-checkbox>
                                <el-checkbox :label="3">周二</el-checkbox>
                                <el-checkbox :label="4">周三</el-checkbox>
                                <el-checkbox :label="5">周四</el-checkbox>
                                <el-checkbox :label="6">周五</el-checkbox>
                                <el-checkbox :label="7">周六</el-checkbox>
                                <el-checkbox :label="1">周日</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </el-form-item>
                    <div class="m-t-26">
                        <el-select v-model="ruleForm.rule.beginHour" placeholder="请选择" class="hour-select" :disabled='ruleForm.rule.timeType == 1?true:false' @change="changeBegin">
                            <el-option v-for="hour in hourData" :key="hour" :value="hour" :label="hour" :disabled="hour>=ruleForm.rule.endHour&&ruleForm.rule.endHour!='00'"></el-option>
                        </el-select>
                        <span>：00</span>
                        <span>~</span>
                        <el-select v-model="ruleForm.rule.endHour" placeholder="请选择" class="hour-select" :disabled='ruleForm.rule.timeType == 1?true:false'>
                            <el-option v-for="hour in hourData2" :key="hour" :value="hour" :label="hour" :disabled="hour<=ruleForm.rule.beginHour"></el-option>
                        </el-select>
                        <span>：00</span>
                    </div>
                    <el-form-item label="通知频次：" autocomplete="off" prop="requency">
                        <div class="p-t-40">共通知<el-input class="frequency" v-model.number="ruleForm.rule.times" @input="replaceNum($event,'times')"></el-input>次，每<el-input class="frequency" v-model.number="ruleForm.rule.frequency" @input="replaceNum($event,'frequency')"></el-input>分钟通知1次</el-input></div>
                    </el-form-item>
                    <el-form-item label="备注：" prop="note">
                        <el-input
                            type="textarea"
                            class="remarks"
                            v-model="ruleForm.note"
                            maxlength="256"
                            show-word-limit
                            id="addRemarks"
                            placeholder="请输入内容">
                        </el-input>
                    </el-form-item>
                </div>
                <div class="rule-box-right">
                    <p class="rule-box-title">消息类别与通知方式</p>
                    <div class="scroll-lits-box">
                        <div class="notice-lists-box">
                            <div class="notice-list title-type">
                                <span>消息类型</span>
                                <el-checkbox-group v-model="messageType" class="notice-type-select" @change="changeMsg">
                                    <el-checkbox :label="1">站内消息</el-checkbox>
                                    <el-checkbox :label="2">公众号消息</el-checkbox>
                                    <el-checkbox :label="3">短信</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="notice-list">
                                <span>设备事件</span>
                                <el-checkbox-group v-model="ruleForm.rule.deviceEvent" class="notice-type-select" @change="changeForm">
                                    <el-checkbox :label="1">站内消息</el-checkbox>
                                    <el-checkbox :label="2">公众号消息</el-checkbox>
                                    <el-checkbox :label="3">短信</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="notice-list">
                                <span>维保计划</span>
                                <el-checkbox-group v-model="ruleForm.rule.servicePlan" class="notice-type-select" @change="changeForm">
                                    <el-checkbox :label="1">站内消息</el-checkbox>
                                    <el-checkbox :label="2">公众号消息</el-checkbox>
                                    <el-checkbox :label="3">短信</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="notice-list">
                                <span>计划任务</span>
                                <el-checkbox-group v-model="ruleForm.rule.taskPlan" class="notice-type-select" @change="changeForm">
                                    <el-checkbox :label="1">站内消息</el-checkbox>
                                    <el-checkbox :label="2">公众号消息</el-checkbox>
                                    <el-checkbox :label="3">短信</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="notice-list">
                                <span>企业授权到期</span>
                                <el-checkbox-group v-model="ruleForm.rule.companyExpire" class="notice-type-select" @change="changeForm">
                                    <el-checkbox :label="1">站内消息</el-checkbox>
                                    <el-checkbox :label="2">公众号消息</el-checkbox>
                                    <el-checkbox :label="3">短信</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="notice-list">
                                <span>设备报警-确认</span>
                                <el-checkbox-group v-model="ruleForm.rule.alarmConfirm" class="notice-type-select" @change="changeForm">
                                    <el-checkbox :label="1">站内消息</el-checkbox>
                                    <el-checkbox :label="2">公众号消息</el-checkbox>
                                    <el-checkbox :label="3">短信</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="notice-list">
                                <span>设备报警-恢复</span>
                                <el-checkbox-group v-model="ruleForm.rule.alarmRecover" class="notice-type-select" @change="changeForm">
                                    <el-checkbox :label="1">站内消息</el-checkbox>
                                    <el-checkbox :label="2">公众号消息</el-checkbox>
                                    <el-checkbox :label="3">短信</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="notice-list">
                                <span>平台报警</span>
                                <el-checkbox-group v-model="ruleForm.rule.systemError" class="notice-type-select" @change="changeForm">
                                    <el-checkbox :label="1">站内消息</el-checkbox>
                                    <el-checkbox :label="2">公众号消息</el-checkbox>
                                    <el-checkbox :label="3">短信</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <p class="notice-type-title">设备报警-级别</p>
                            <div class="notice-list">
                                <span>提示</span>
                                <el-checkbox-group v-model="ruleForm.rule.alarmLevelInfor" class="notice-type-select" @change="changeForm">
                                    <el-checkbox :label="1">站内消息</el-checkbox>
                                    <el-checkbox :label="2">公众号消息</el-checkbox>
                                    <el-checkbox :label="3">短信</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="notice-list">
                                <span>告警</span>
                                <el-checkbox-group v-model="ruleForm.rule.alarmLevelWarn" class="notice-type-select" @change="changeForm">
                                    <el-checkbox :label="1">站内消息</el-checkbox>
                                    <el-checkbox :label="2">公众号消息</el-checkbox>
                                    <el-checkbox :label="3">短信</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="notice-list">
                                <span>故障</span>
                                <el-checkbox-group v-model="ruleForm.rule.alarmLevelError" class="notice-type-select" @change="changeForm">
                                    <el-checkbox :label="1">站内消息</el-checkbox>
                                    <el-checkbox :label="2">公众号消息</el-checkbox>
                                    <el-checkbox :label="3">短信</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <p class="notice-type-title">设备报警-类别</p>
                            <div class="notice-list" v-for="(id,i) in ruleForm.rule.alarmCategory" :key="i">
                                <span>{{warningData[i].name}}</span>
                                <el-checkbox-group v-model="ruleForm.rule.alarmCategoryNotice[i]"  class="notice-type-select" @change="changeForm">
                                    <el-checkbox :label="1">站内消息</el-checkbox>
                                    <el-checkbox :label="2">公众号消息</el-checkbox>
                                    <el-checkbox :label="3">短信</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <p class="notice-type-title">工单</p>
                            <div class="notice-list">
                                <span>待审批</span>
                                <el-checkbox-group v-model="ruleForm.rule.woPendApproval" class="notice-type-select" @change="changeForm">
                                    <el-checkbox :label="1">站内消息</el-checkbox>
                                    <el-checkbox :label="2">公众号消息</el-checkbox>
                                    <el-checkbox :label="3">短信</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="notice-list">
                                <span>待执行</span>
                                <el-checkbox-group v-model="ruleForm.rule.woPendExecute" class="notice-type-select" @change="changeForm">
                                    <el-checkbox :label="1">站内消息</el-checkbox>
                                    <el-checkbox :label="2">公众号消息</el-checkbox>
                                    <el-checkbox :label="3">短信</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="notice-list">
                                <span>完成</span>
                                <el-checkbox-group v-model="ruleForm.rule.woCompleted" class="notice-type-select" @change="changeForm">
                                    <el-checkbox :label="1">站内消息</el-checkbox>
                                    <el-checkbox :label="2">公众号消息</el-checkbox>
                                    <el-checkbox :label="3">短信</el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div>
                </div>
            </el-form>
            <p class="popup-btn-box p-r"><el-button type="primary" :disabled="editRuleShow&&!changeBtn(nowObj)||$store.state.isLook" id="showRule" @click="submitRule">确定</el-button> <el-button @click="cancelRule" id="closeRule2">取消</el-button></p>
        </div>
    </div>
</template>
<script>
import Pagination from "@/components/PublicAssembly/pagination"
import Organize from "@/components/PublicAssembly/organize"
export default {
    data() {
        var valiName = (rule, value, callback) =>{      //规则名称
            // let reg=/^[A-Za-z0-9-_\u4e00-\u9fa5]{1,32}$/;
            if(value == "" ||value==null){
                callback(new Error('请输入规则名称'));
            }else if(value.length>32){
                callback(new Error('规则名称由1~32个字符构成'));
            }else{
                callback();
            }
        }
        var valiRequency= (rule, value, callback) =>{      //通知频次
            if(this.ruleForm.rule.times == "" ||this.ruleForm.rule.times==null){
                callback(new Error('通知次数不能为空'));
            }else if(this.ruleForm.rule.frequency == "" ||this.ruleForm.rule.frequency==null){
                callback(new Error('通知间隔不能为空'));
            }else{
                callback();
            }
        }
        var valinotice= (rule, value, callback) =>{      //通知对象
            if(this.oldRoleList.length == 0){
                callback(new Error('通知对象不能为空'));
            }else{
                callback();
            }
        }
        var valiType= (rule, value, callback) =>{      //通知时段
            if(this.ruleForm.rule.timeType == 2 && this.ruleForm.rule.week.length == 0){
                callback(new Error('请选择通知时段具体周'));
            }else{
                callback();
            }
        }
        return {
            nullData:require('@/assets/image/index/nullData.png'),
            right:require('@/assets/image/index/right.png'),
            notes:require('@/assets/image/organize/notes.png'),
            edit0:require('@/assets/image/organize/edit.png'),
            edit1:require('@/assets/image/organize/edit4.png'),
            down:require('@/assets/image/organize/down.png'),
            select:require('@/assets/image/organize/select.png'),
            branch:require("@/assets/image/company/ptzu.png"),
            user:require('@/assets/image/company/user.png'),
            jczu:require('@/assets/image/company/jczu.png'),
            qyzu:require('@/assets/image/company/qyzu.png'),
            add:require('@/assets/image/organize/addrole.png'),
            delIcon:require('@/assets/image/organize/delete.png'),
            rule:require('@/assets/image/company/rule.png'),
            rule1:require('@/assets/image/company/rule1.png'),
            roleTree:[],
            noticeTree:[],
            orCode:'',
            totalCount:1,
            pageSize:10,
            pageNumber:1,
            dataList:[],
            userList:[],
            searchVal:"",
            recoveryName:"",
            state:0,
            addRuleShow:false,
            editRuleShow:false,
            delRuleShow:false,
            enableRuleShow:false,
            disableRuleShow:false,
            selectShow:false,
            setGropup:false,
            roleShow:false,
            roleBoxShow:false,
            nowObj:{},
            nowIndex:null,
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            messageType:[],         //消息类型
            oldMessageType:[],      //消息类型
            result:{},
            ruleForm:{
                name:'',
                type:2,
                target:[],
                rule:{
                    timeType:1,
                    week:[],
                    beginHour:"00",
                    endHour:"01",
                    times:'',
                    frequency:null,
                    alarmLevelInfor:[],     //报警级别 - 提示
                    alarmLevelWarn:[],      //报警级别 - 告警
                    alarmLevelError:[],     //报警级别 - 故障
                    alarmConfirm:[],        //报警确认
                    alarmRecover:[],        //报警恢复
                    deviceEvent:[],         //设备事件
                    servicePlan:[],         //维保计划
                    taskPlan:[],            //计划任务
                    companyExpire:[],       //企业授权过期
                    systemError:[],         //平台报警
                    alarmCategory:[],
                    alarmCategoryNotice:[],
                    woPendApproval:[],     //工单-待审批
                    woPendExecute:[],     //工单-待执行
                    woCompleted:[],     //工单-完成
                },
                note:null,
            },
            verifyForm:{
                verifyCode:'',
            },
            rules:{
                name:[{validator: valiName, required: true, trigger: 'blur'}],
                type:[{required: true, trigger:'change'}],
                noticeObj:[{required: true,validator: valinotice, trigger: 'change'}],
                requency:[{validator: valiRequency, required: true, trigger: 'blur'}],
                timeType:[{validator: valiType, required: true, trigger:'change'}],
                verifyCode:[{ message: '请输入验证码', required: true, trigger: 'blur' }],
                note:[{required: false, trigger:'blur'}],
            },
            orSuperior:{},
            hourData:[],
            hourData2:[],
            currencyRole:[],    //通用角色列表
            customRole:[],      //自定义角色列表
            roleCode:"",        //当前选中的角色
            delCode:"",         //当前选中要删除的角色
            allUserList:[],     //所有用户
            // allRoleList:[],     //所有角色
            addRoleList:[],     //已添加的角色列表
            oldRoleList:[],     //已添加的旧角色列表
            warningData:[],     //报警类别
            functionSet:[],
            roleId:null,
            orSuperiorData:[],
            functionShow:false,
            VerifyArr:[],
            verifyCode:'',
            second:60,
            getCodeShow:true,
            countdownShow:false,
            phone:'',
            time:null,
            oldcode:'',
            oldorSuperior:{},
            noset:false
        }
    },
    components:{
        Pagination,
        Organize
    },
    created() {
        this.$store.state.activeIndex = '/NoticeRuleList'
        this.pageSize=this.$store.state.userConfig.rowsPerPage;
        // this.getlist();
        this.setHour()
        this.getWarning()
        this.getTree('a');
        this.phone=this.hidePhone(this.$store.state.userData.mobile);
    },
    methods: {
        // 获取列表
        getlist(){
            let parm = {
                pageNumber:this.pageNumber,
                length:this.pageSize,
                code:this.orCode,
                keyword:this.searchVal,
            }
            switch(this.state){
                case 0:
                    parm.state=null;
                    parm.type=null;
                    break;
                case 1:
                    parm.state=1;
                    break;
                case 2:
                    parm.state=2;
                    break;
                case 3:
                    parm.type=1 ;
                    break;
                case 4:
                    parm.type=2 ;
                    break;
            }
            this.get('/NoticeRule/query',parm).then((res)=>{
                if(res.success){
                    this.dataList=res.result.data
                    this.totalCount = res.result.totalCount
                }else{
                    this.$message({
                        message: `获取列表数据失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        // 添加时间列表
        setHour(){
            for(let i=0;i<24;i++){
                let hour
                if(i<10){
                    hour = "0"+i
                }else{
                    hour = i.toString()
                }
                this.hourData.push(hour)
            }
            for(let i=1;i<=24;i++){
                let hour
                if(i<10){
                    hour = "0"+i
                }else{
                    hour = i.toString()
                }
                this.hourData2.push(hour)
            }
        },
        // 返回列表
        toList(){
            // 初始数据
            this.addRuleShow = false;
            this.editRuleShow =false;
            this.messageType = [];
            this.oldMessageType=[];
            this.ruleForm=this.$options.data().ruleForm
        },
        replaceNum(v,key){
          console.log(v)
          this.ruleForm.rule[key] = v.replace(/[^0-9]/g, '')
        },
        // 获取所有用户
        getAllUser(code){
            this.noticeTree = this.clone(this.orSuperiorData)   //重置通知树
            // console.log(this.oldcode, code)
            if(this.oldcode!=this.noticeTree[0].code&&code){
                this.get('/User/getList',{code:code||this.noticeTree[0].code}).then((res)=>{
                    if(res.success){
                        if(!Array.isArray(res.result)){res.result=[]}
                        this.oldcode=this.noticeTree[0].code
                        this.allUserList = res.result;
                        // 将用户添加进树中
                        for(let obj of res.result){
                            obj.name = obj.displayName
                            obj.userType=obj.type
                            obj.type = 4
                            let tree = this.$refs.noticeTree.getNode(obj.groupCode)
                            if(tree){
                                if(tree.data.children == null){
                                    tree.data.children = []
                                }
                                tree.data.children.unshift(obj)
                            }
                        }
                    }else{
                        this.$message({
                            type:"warning",
                            message:"获取用户数据失败："+res.message,
                        })
                    }
                })
            }else{

            }
        },
        //获取报警类别
        getWarning(){
            this.get('/Dict/getListByType',{type:2}).then((res)=>{
                if(res.success){
                    this.warningData=res.result
                    this.setRuleForm()
                }else{
                    this.$message({
                        message: `获取报警类别数据失败:${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        //获取组织树
        getTree(type){
            this.get('/Group/getOrganizationTree').then((res)=>{
                if(res.success){
                    this.roleTree=res.result;
                    this.orCode =  this.roleTree[0].code
                    this.$store.state.treeData = this.roleTree
                    this.orSuperior = this.$store.state.treeData[0]
                    this.oldorSuperior = this.clone(this.orSuperior)
                    this.functionSet = this.$store.state.treeData[0].functionSet.split(',')  //权限集
                    this.$store.state.expandedArr=[]
                    this.expanded(this.$store.state.treeData,1) //展开树
                    this.orSuperiorData=[]  //初始化树
                    if(type == 'a'){
                        this.roleId = this.$store.state.treeData[0].roleId
                        this.VerifyArr=localStorage.getItem('verifyCodeModule').split(',').map(Number)
                        this.getlist()
                    }
                    for(let obj of res.result){
                        if(obj.roleId == this.roleId){  //获取当前角色下树数据
                            obj = this.clone(obj)
                            this.orSuperiorData.push(obj)
                            if(type=='a'){
                                this.getAllUser(this.roleTree[0].code)
                            }
                            return
                        }
                    }
                }
            })
        },
        //修改树组织
        setTree(){
            this.getTree()
        },
        // 获取的当前组
        setOrId(node){
            if(node[0].roleId != this.roleId){
                this.roleId = node.roleId
                this.orSuperiorData = []
                for(let obj of this.$store.state.treeData){
                    if(node[0].roleId == obj.roleId){   //获取当前角色下的树数据
                        obj = this.clone(obj)
                        this.orSuperiorData.push(obj)   //所属组
                    }
                }
            }
            this.orCode=node[0].code;
            this.orSuperior=node[0];
            this.oldorSuperior = this.clone(this.orSuperior)
            this.searchVal = '',
            this.pageNumber=1,
            this.setGropup = true
            this.getlist()
            this.functionSet = node[1]
            this.getAllUser()
        },
        //打开添加角色弹窗
        showRole(name){
            this.noset = false  //初始
            // this.changeForm()
            for(let obj of this.allUserList){
                obj.name = obj.displayName
                obj.userType=obj.type
                obj.type = 4
                let tree = this.$refs.noticeTree.getNode(obj.groupCode)
                if(tree){   //将用户添加进通知角色树
                    if(tree.data.children == null){
                        tree.data.children = []
                    }
                    this.$refs.noticeTree.getNode(obj.groupCode).data.children.unshift(obj)
                }
            }
            this.addRoleList = this.clone(this.oldRoleList)
            this.roleShow = true;
            this.$store.state.mask=true
            this.$forceUpdate();    //强制刷新下吧
        },
        // //添加角色
        // addRole(role){
        //     role.selectType=true;
        //     for(let obj of this.addRoleList){
        //         if(role.id == obj.id){
        //             return
        //         }
        //     }
        //     this.addRoleList.push(role)
        // },
        //删除角色
        delRole(role,a){
            // console.log(role,a)
            this.addRoleList.splice(a,1)
            this.noset = true   //避免因触发tree 组件的事件而导致删除两次
            this.$refs.noticeTree.setChecked(role,false)
            this.$forceUpdate()
        },
        //修改角色
        editRole(){
            // let id="",name="";
            for(let role of this.addRoleList){
                this.ruleForm.target.push(role.code)
            }
            this.roleShow=false;
            this.$store.state.mask=false;
            this.oldRoleList = this.clone(this.addRoleList) //保存此次角色列表
        },
        // 选择通知组或企业
        handleCheckChange(data, checked, indeterminate){
            if(this.noset){ //删除按钮进行的操作不执行下面方法
                this.noset = false
                return
            }
            if(checked){
                if(this.$refs.noticeTree.getNode(data.code).parent){
                    data.groupName=this.$refs.noticeTree.getNode(data.code).parent.data.name    //获取通知对象上级组
                }
                // this.ruleForm.target.push(data.code);
                this.addRoleList.push(data)
            }else{
                for(let i in this.addRoleList){
                    if(data.code == this.addRoleList[i].code){
                        // this.ruleForm.target.splice(i,1)
                        this.addRoleList.splice(i,1)
                    }
                }
            }
            this.$forceUpdate()
        },
        //关闭角色弹窗
        closeRole(){
            this.roleShow=false;
            this.$store.state.mask=false;
            this.noset = true
            this.$refs.noticeTree.setCheckedKeys([],false)  //清除通知对象树上的已勾选的节点
            let arr = []
            for(let role of this.addRoleList){
                role.selectType = false //重置选中状态
            }
            for(let i in this.oldRoleList){
                arr.push(this.oldRoleList[i].code)
                if(i==this.oldRoleList.length-1){
                    this.noset = true
                    this.$refs.noticeTree.setCheckedKeys(arr,true)  //设置已勾选
                }
            }

            this.addRoleList = this.clone(this.oldRoleList) //还原上次添加的角色列表
        },
        target(){
        },
        // 修改分页size
        setSize(pageObj){
            this.pageSize=pageObj.size;
            this.getlist()
        },
        // 修改页数
        setNum(number){
            this.pageNumber=number;
            if(this.setGropup){
                this.setGropup=false
                return
            }
            this.getlist()
        },
        // 头部标签
        headClick(i){
            this.state = i
            this.pageNumber = 1;
            this.getlist()
        },
        //搜索
        search(){
            this.getlist()
        },
        setRuleForm(type){
            if(type=='a'){
                this.ruleForm.rule.alarmCategory=[]
                for (let i in this.warningData) {
                    this.ruleForm.rule.alarmCategory.push(this.warningData[i].id);
                    this.ruleForm.rule.alarmCategoryNotice[i]=this.nowObj.rule.alarmCategoryNotice[i]||[];
                }
            }else{
                for (let key of this.warningData) {
                    this.ruleForm.rule.alarmCategory.push(key.id);
                    this.ruleForm.rule.alarmCategoryNotice.push([]);
                }
            }
        },
        // 打开弹窗
        operate(obj,name,i){
            if(name!='editRuleShow'&&!this.functionSet.includes('noticeRuleEdit')||name!='editRuleShow'&&obj.type==1&&!this.functionSet.includes('noticeRuleNormal')||name!='editRuleShow'&&this.$store.state.isLook){
                return
            }
            if(this.VerifyArr.includes(6)&&!this.$store.state.isLook&&obj.type==1&&this.functionSet.includes('noticeRuleNormal')){
                this.$store.state.mask=true;
                this.functionShow = true;
                return
            }
            this.oldRoleList=[],
            this.addRoleList = [],
            this.messageType = [];
            this.oldMessageType=[];
            this.nowIndex = i;
            this[name]=true;
            if(name=="editRuleShow"){
                this.get('/NoticeRule/get',{id:obj.id}).then((res)=>{
                    if(res.success){
                        let data = res.result;
                        if(data.type!=1){
                            this.orSuperior =this.clone(this.$refs.Ntree.getNode(data.groupCode).data)
                        }
                        // data.rule =JSON.parse(data.rule)
                        this.nowObj = this.clone(data);
                        data.target==""?data.target=[]:data.target = data.target.split(',')
                        if(Number(data.rule.beginHour)<10){
                            data.rule.beginHour = '0'+Number(data.rule.beginHour)
                        }
                        if(Number(data.rule.endHour)<10){
                            data.rule.endHour = '0'+Number(data.rule.endHour)
                        }
                        if(!data.rule.woCompleted) data.rule.woCompleted=[]
                        if(!data.rule.woPendApproval) data.rule.woPendApproval=[]
                        if(!data.rule.woPendExecute) data.rule.woPendExecute=[]
                        this.ruleForm = data
                        this.setRuleForm('a')
                        let arr = data.target
                        this.$refs.noticeTree.setCheckedKeys(data.target,true);
                        for(let code of arr){
                            let obj = this.$refs.noticeTree.getNode(code)
                            if(obj){
                                this.oldRoleList.push(obj.data)
                            }
                        }
                        this.addRoleList = this.clone(this.oldRoleList);
                        this[name]=true;
                        this.result = this.clone(this.ruleForm)
                        this.changeForm()
                    }else{
                        this.$message({
                            type:"warning",
                            message:`获取通知规则失败${res.message}`
                        })
                    }
                })
                return
            }else if(name=="addRuleShow"){
                this.ruleForm = this.$options.data().ruleForm
                this.result = {}
                this.setRuleForm()
                this[name]=true;
                return
            }
            this[name]=true;
            this.$store.state.mask=true;
            this.nowObj = obj;
        },
        // 关闭弹窗
        close(name){
            this[name]=false;
            this.$store.state.mask=false;
            this.verifyForm.verifyCode = ''
        },
        // 添加规则弹窗
        addRule(){
            this.oldRoleList=[],
            this.addRoleList = [],
            this.$refs.noticeTree.setCheckedNodes([])
            this.orSuperior = this.clone(this.oldorSuperior)
            this.addRuleShow=true;
            this.messageType = [];
            this.oldMessageType=[];
        },
        // 展开上级组
        showSelect(){
            var box = this.$refs.selectbox;
            this.selectShow=true;
        },
        // 获取用户点击的上级组节点
        selectId(data){
            this.orSuperior=data;
            this.selectShow=false;
            this.changeForm()
        },
        // 验证权限按钮
        changeBtn(data){
            if(data.type==1&&this.functionSet.includes('noticeRuleEdit')&&this.functionSet.includes('noticeRuleNormal')){
                return true
            }else if(data.type==2&&this.functionSet.includes('noticeRuleEdit')){
                return true
            }else{
                return false
            }
        },
        changeBegin(val){
            if(Number(val)>Number(this.ruleForm.rule.endHour)){
                let num = Number(val)+1
                if(num<10){
                    num='0'+num
                }
                this.ruleForm.rule.endHour=num.toString()
            }
        },
        // 删除通知规则
        delNoticeRule(){
            this.get('/NoticeRule/remove',{id:this.nowObj.id}).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.getlist()
                }else{
                    this.$message({
                        message: `删除失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
            this.$store.state.mask=false;
            this.delRuleShow=false;
        },
        // 停用通知规则
        disNoticeRule(){
            this.get('/NoticeRule/disable',{id:this.nowObj.id}).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '停用成功',
                        type: 'success'
                    });
                    this.dataList[this.nowIndex].state=2
                }else{
                    this.$message({
                        message: `停用失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
            this.$store.state.mask=false;
            this.disableRuleShow=false;
        },
        // 启用通知规则
        enaNoticeRule(){
            this.get('/NoticeRule/enable',{id:this.nowObj.id}).then((res)=>{
                if(res.success){
                    this.$message({
                        message: '启用成功',
                        type: 'success'
                    });
                    this.dataList[this.nowIndex].state=1
                }else{
                    this.$message({
                        message: `启用失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
            this.$store.state.mask=false;
            this.enableRuleShow=false;
        },
        // 提交规则
        submitRule(){
            this.$refs.addAlarm.validate((valid) => {
                if(valid){
                    let parm = {
                        requestId:1,
                        name:this.ruleForm.name,
                        type:this.ruleForm.type,
                        groupCode:this.ruleForm.type==1?'':this.orSuperior.code,
                        target:[],
                        targetName:[],
                        note:this.ruleForm.note,
                        rule:this.ruleForm.rule
                    }
                    for(let obj of this.oldRoleList){
                        parm.target.push(obj.code)
                        parm.targetName.push(obj.name)
                    }
                    parm.targetName = parm.targetName.toString(),
                    parm.target = parm.target.toString(),
                    parm.rule.beginHour = Number(parm.rule.beginHour)
                    parm.rule.endHour = Number(parm.rule.endHour)
                    parm.rule.frequency = parm.rule.frequency==""?null: Number(parm.rule.frequency)
                    parm.rule.times = parm.rule.frequency==""?null: Number(parm.rule.times)
                    parm.rule.week.sort()
                    if(this.addRuleShow){
                        this.postNoJson('/NoticeRule/create',parm).then((res)=>{
                            if(res.success){
                                this.$message({
                                    type:'success',
                                    message:'创建规则成功'
                                })
                                this.getlist()
                                this.ruleForm = this.$options.data().ruleForm
                                this.setRuleForm()
                                this.messageType = [];
                                this.oldMessageType=[];
                                this.addRuleShow = false
                                this.$store.state.isEdit = false
                            }else{
                                this.$message({
                                    type:'warning',
                                    message:`创建规则失败：${res.message}`
                                })
                            }
                        })
                    }else{
                        parm.id=this.nowObj.id;
                        parm.state=this.nowObj.state
                        this.postNoJson('/NoticeRule/update',parm).then((res)=>{
                            if(res.success){
                                this.$message({
                                    type:'success',
                                    message:'编辑规则成功'
                                })
                                this.get('/NoticeRule/get',{id:parm.id}).then((res)=>{
                                    if(res.success){
                                        this.$set(this.dataList,this.nowIndex,res.result)
                                    }
                                })
                                this.ruleForm = this.$options.data().ruleForm
                                this.setRuleForm()
                                this.messageType = [];
                                this.oldMessageType=[];
                                this.editRuleShow = false
                                this.$store.state.isEdit = false
                            }else{
                                this.$message({
                                    type:'warning',
                                    message:`编辑规则失败：${res.message}`
                                })
                            }
                        })
                    }
                }
            })

        },
        // 批量修改值
        changeMsg(val){
            if(this.oldMessageType.length<this.messageType.length){
                for(let type of this.messageType){
                    for(let key of Object.keys(this.ruleForm.rule)){
                        if(typeof this.ruleForm.rule[key] == "object"){
                            if(key == 'alarmCategoryNotice'){
                                for(let arr of this.ruleForm.rule[key]){
                                    if(!arr.includes(type)){
                                        arr.push(type)
                                    }
                                }
                            }else if(key,key!='week' && key !='alarmCategory' &&key!="alarmCategoryNotice" &&key!='frequency'){
                                if(!this.ruleForm.rule[key].includes(type)){
                                    this.ruleForm.rule[key].push(type)
                                }
                            }
                        }
                    }
                }
            }else{
                for(let type of this.oldMessageType){
                    if(!this.messageType.includes(type)){
                        for(let key of Object.keys(this.ruleForm.rule)){
                            if(typeof this.ruleForm.rule[key] == "object"){
                                if(key == 'alarmCategoryNotice'){
                                    for(let arr of this.ruleForm.rule[key]){
                                        arr.forEach(function(item, index, obj) {
                                            if(item == type) {
                                                obj.splice(index, 1);
                                            }
                                        })
                                    }
                                }else if(key,key!='week' && key !='alarmCategory' &&key!="alarmCategoryNotice" &&key!='frequency'){
                                    this.ruleForm.rule[key].forEach(function(item, index, obj) {
                                        if(item == type) {
                                            obj.splice(index, 1);
                                        }
                                    })
                                }
                            }
                        }
                    }
                }
            }
            this.oldMessageType = this.messageType
            this.changeForm()
        },
        // 获取验证码
        getCode(){
            this.get('/UserProfile/sendVerifyCode').then((res)=>{
                if(res.success){
                    this.getCodeShow=false
                    this.countdownShow=true
                    const TIME_COUNT = 60;
                    this.$message({
                        message: '验证码发送成功',
                        type: 'success'
                    });
                    if (!this.timer) {
                        this.second = TIME_COUNT;
                        this.show = false;
                        this.timer = setInterval(() => {
                            if (this.second > 0 && this.second <= TIME_COUNT) {
                                this.second--;
                            } else {
                                this.getCodeShow = true;
                                this.countdownShow=false;
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000)
                    }
                }else{
                    this.$message({
                        message: `验证码发送失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        // 用户提权
        Privilege(){
            this.$refs.verifyCode.validate((valid) => {
                if (valid) {
                    this.post('/UserProfile/privilege',{verifyCode:this.verifyForm.verifyCode}).then(res=>{
                        if(res.success){
                            this.$message({
                                message:'提权成功',
                                type:'success'
                            })
                            this.VerifyArr.splice(this.VerifyArr.indexOf(6),1)
                            localStorage.setItem('verifyCodeModule',this.VerifyArr)
                            this.$store.state.mask=false
                            this.functionShow=false
                            this.getCodeShow = true;
                            this.countdownShow=false;
                            clearInterval(this.timer);
                            this.timer = null;
                            this.verifyForm.verifyCode = ''
                        }else{
                            this.$message({
                                message:`提权失败：${res.message}`,
                                type:'warning'
                            })
                        }
                    })
                }
            })
        },
        // 取消修改或者添加规则
        cancelRule(){
            this.addRuleShow =false;
            this.editRuleShow =false;
            this.setRuleForm()
            this.messageType = [];
            this.oldMessageType=[];
            this.ruleForm = this.$options.data().ruleForm
            this.result = this.clone(this.ruleForm)
        },
        changeForm(){
          console.log(JSON.stringify(this.result)==JSON.stringify(this.ruleForm))
          if(JSON.stringify(this.result)==JSON.stringify(this.ruleForm)){
              this.$store.state.isEdit = false
          }else{
              this.$store.state.isEdit = true
          }
        }
    },
    watch: {
        roleShow(){
            this.changeForm()
        },
        // 判断用户是否在编辑/新增通知规则
        addRuleShow(){
            if(!this.addRuleShow){
              this.result = {}
              this.$store.state.isEdit = false
            }
        },
        editRuleShow(){
            if(this.editRuleShow&&!this.$store.state.isLook&&this.functionSet.includes('noticeRuleEdit')){
                this.$store.state.isEdit = false
            }else{
                this.$store.state.isEdit = false
                this.result = {}
            }
        }
    }
}
</script>
<style scoped>
    .tabs-box{
        float: left;
        height: 40px;
        overflow: hidden;
        background-color: #fff;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border: 1px solid #d2d2d2;
        position: absolute;
        top: -43px;
    }
    .tabs-box div{
        float: left;
        padding: 9px 0;
    }
    .tabs-box span{
        display: inline-block;
        width: 110px;
        font-size: 14px;
        line-height: 22px;
        border-left: 1px solid #e2e2e2;
        cursor:pointer;
        float: left;
    }
    .tabs-box>div:first-child span{
        border: none;
    }
    .list-box{
        position: absolute;
        top: 36px;
        left: 328px;
        right: 0;
        bottom: 0;
    }
    .list-top{
        margin: 0px 16px 15px 16px;
        padding-top: 24px;
        height: 34px;
    }
    .add-btn{
        float: left;
        line-height: 32px !important;
        padding: 0 15px !important;
    }
    .search{
        float: right;
        width: 388px;
        margin-right: 10px;
    }
    .search-btn{
        float: right;
    }
    .company-list{
        overflow: hidden;
        margin-bottom: 32px;
        height: 90%;
    }
    .scroll{
        overflow: auto;
        width: 97.6%;
        height: 88%;
        max-height: 88% !important;
        margin: 0 16px;
        box-sizing: border-box;
        border: 1px solid #f2f2f2;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    /* .scroll>ul:last-child{
        border-bottom: 0;
    } */
    .list-title,.list-details{
        display: flex;
        justify-content: space-around;
        line-height: 44px;
        font-size: 14px;
        color: #636363;
    }
    .list-title{
        background: #eeeeee;
        margin: 0 17px;
    }
    .list-title li,.list-details li{
        width: 200px;
        margin: 0 20px;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .list-details{
        border-top:1px solid #f2f2f2;
    }
    .operate span{
        margin: 0 4px;
        color: #5087e4;
    }
    .w-18{
        width: 18% !important;
    }
    .list-details:last-child{
        border-bottom:1px solid #f2f2f2;
    }
    img.notes{
        position: relative;
        left: 5px;
        top: 3px;
    }
    .w-90{
        width: 90px !important;
        margin-right: 40px !important;
    }
    .active{
        background: #5087e4;
        color: #fff;
    }
    .active>span{
        border: 0;
    }
    .bg{
        width: 100%;
        height: 90%;
    }
    /* 弹窗 */
    .popup>div{
        position: fixed;
        top: 10%;
        left:50%;
        padding:0 28px;
        box-sizing: border-box;
        margin-left:-572px;
        width: 578px;
        background-color: #fff;
        z-index: 999;
        padding-bottom: 30px;
        height: 285px;
        text-align: left;
    }
    .popup-title{
        font-size: 16px;
        line-height: 64px;
        border-bottom: 1px solid #e5e5e5;
        margin-bottom: 12px;
        text-align: left;
    }
    .popup-lab{
        font-size: 14px;
        line-height: 30px;
        margin-bottom: 14px;
    }
    .popup-btn-box{
        text-align: center;
        margin-top: 30px;
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 38px;
    }
    .popup-btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    .popup-btn-box.p-r{
        position: absolute !important;
        bottom: 0;
        margin-bottom: 8px;
    }
    .b-32{
        position: absolute;
        bottom: 32px;
        left: 0;
    }
    i.close{
        font-size: 20px;
        float: right;
        margin-top: 24px;
    }
    .b-32{
        position: absolute;
        bottom: 32px;
        left: 0;
    }
    .btn-box{
        position: absolute;
        text-align: center;
        bottom: 36px;
        width: 100%;
        left: 0;
    }
    .btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    .rule-box{
        text-align: left;
        margin-left: 16px;
        width: 99%;
        min-width: 973px;
        height: 98%;
        position: absolute;
        left: 0;
        top: 0;
        /* background-color: aqua; */
    }
    .breadcrumb{
        font-size: 16px;
        text-align: left;
    }
    i>img.right{
        width: 12px;
        margin: 0 6px;
    }
    .rule-box-left{
        height: 101%;
        min-height: 723px;
        float: left;
        background-color: #fff;
        width: 33.25%;
        margin:16px 18px 0 0 ;
        border-radius: 5px;
        padding:12px 30px;
        box-sizing: border-box;
    }
    .rule-box-right{
        position: relative;
        height: 101%;
        min-height: 723px;
        float: left;
        background-color: #fff;
        width: 64.5%;
        margin-top: 16px;
        border-radius: 5px;
        padding:12px 30px;
        box-sizing: border-box;
    }
    .m-l-12{
        margin-left: 12px;
    }
    .rule-type{
        font-size: 14px;
        line-height: 14px;
        position: relative;
        top: -4px;
    }
    .m-t-0{
        margin-bottom: 0 !important;
    }
    .or-Superior{
        height: 34px;
        line-height: 34px;
        border-radius: 5px;
        border: 1px solid #e5e5e5;
        padding:0 14px;
        position: relative;
        box-sizing: border-box;
        margin-top: 38px;
    }
    .or-Superior>i{
        float: right;
        line-height: 30px;
        position: relative;
        right: -6px;
    }
    .or-Superior img{
        width: 22px;
        margin-top: 6px;
    }
    .organize{
        position: absolute;
        top: 36px;
        bottom: 0;
    }
    .select-box{
        position: absolute;
        left: -1px;
        top: 32px;
        border: 1px solid #e5e5e5;
        max-height: 315px;
        overflow: auto;
        width: 100%;
        min-height: 242px;
        border-radius: 5px;
        z-index: 99;
        background: #fff;
    }
    .edit-noticeObj{
        color: #5087e4;
        padding-left: 14px;
        cursor: pointer;
    }
    .edit-noticeObj img{
        left: -7px !important;
    }
    .noticeObj-box{
        width: 100%;
        height: 108px;
        border: 1px solid #dedede;
        overflow: auto;
        line-height: 24px;
        box-sizing: border-box;
        padding:5px 15px;
    }
    .hour-select{
        width: 75px;
    }
    .frequency{
        width: 75px;
        margin: 0 12px;
    }
    .p-t-40{
        padding-top: 40px;
    }
    .rule-box-title{
        font-size: 14px;
        margin-top: 6px;
    }
    .scroll-lits-box{
        position: absolute;
        left: 30px;
        right: 0;
        top: 46px;
        bottom: 14px;
        overflow: auto;
    }
    .notice-lists-box{
        border: 1px solid #e9e9e9;
        border-radius: 5px;
        margin-right: 28px;
        box-sizing: border-box;
    }
    .notice-lists-box .notice-list:last-child{
        border-bottom: 0;
    }
    .notice-list{
        border-bottom: 1px solid #e9e9e9;
        line-height: 40px;
        color: #363636;
        font-size: 14px;
        padding:0 34px;
        display: flex;
        justify-content: space-between;
    }
    .notice-type-select{
        width: 65%;
    }
    .notice-type-title{
        line-height: 46px;
        padding-left: 34px;
        font-size: 14px;
        border-bottom: 1px solid #e9e9e9;
    }
    .tree-disable-input{
        color: #dadada;
        border: 1px solid #ececec;
        line-height: 32px;
        border-radius: 5px ;
        margin-top: 38px;
        padding-left: 14px;
    }
    .content-box{
        height: 418px;
        border: 1px solid #d2d2d2;
        border-bottom: 0;
    }
    .content-box>div{
        float: left;
        height: 100%;
        width: 277.5px;
        line-height: 34px;
    }
    .roleTree,.role-selecting{
        border-right: 1px solid #d2d2d2;
    }
    .roleTree .el-tree{
        height: 95%;
    }
    .tree-box{
        width: 100%;
        height: 390px;
        overflow: auto;
    }
    .currency{
        color: #073178 !important;
    }
    .roleTree-top{
        text-align: center;
        line-height: 28px;
        font-size: 14px;
        background-color: #eee;
    }
    img.tree-icon{
        width: 16px !important;
        position: relative;
        top: 3px;
        left: -2px;
    }
    .user-p{
        padding: 0 12px;
        line-height: 34px !important;
        margin: 0;
        height: 34px;
    }
    .overAuto{
        overflow-y: auto;
        height: 90%;
    }
    .disabled3{
        background-color: #F5F7FA !important;
        color: #C0C4CC !important;
        cursor: not-allowed;
    }
    /* .role-option-box{
        line-height: 28px;
        font-size: 14px;
        margin-bottom: 4px;
        color: #606060;
    }
    .select-icon,.role-icon{
        width: 22px;
        position: relative;
        padding-left: 9px;
        top: 5px;
    }
    .role-icon{
        padding-left: 19px;
    }
    .add-icon{
        width: 16px;
        position: absolute;
        right: 12px;
        top: 10px;
    }
    .del-icon{
        width: 12px;
    }
    .role-option:focus{
        outline: none;
        background-color: #f5f5f5;
    }
    .role-option:hover{
        outline: none;
        background-color: #f5f5f5;
    }
    .added{
        float: right;
        font-size: 12px;
        margin-right: 12px;
        line-height: 31px;
    } */
    .role-option,.del-option{
        position: relative;
    }
    .del-option:hover{
        outline: none;
        background-color: #f5f5f5;
    }
    .selecting-box,.addrole-list{
        overflow: auto;
        height: 390px;
    }
    .addrole-list{
        line-height: 28px;
        font-size: 14px;
        box-sizing: border-box;
    }
    .del-option{
        padding-right: 40px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 14px;
    }
    .del-option:focus{
        outline: none;
        background-color: #f5f5f5;
    }
    .role-icon{
        width: 16px;
        position: relative;
        padding-left: 9px;
        top: 3px;
    }
    .role-icon{
        padding-left: 19px;
    }
    .top-2{
        top: 2px !important;
        left: 10px !important;
    }
    .m-t-26{
        margin-top: 24px !important;
    }
    .popup-role{
        width: 614px !important;
        height: 582px !important;
        margin-left: -307px !important;
        z-index:9999;
        background-color: #fff;
    }
    .title-type{
        background-color: #ececec;
        padding-left: 34px;
        font-size: 14px;
    }
    .add-icon{
        width: 16px;
        position: absolute;
        right: 12px;
        top: 10px;
    }
    .del-icon{
        width: 12px;
    }
    .min-120{
        min-width: 120px;
    }
</style>
<style>
    #NoticeRule .tree .el-tree-node{
        width: 263px;
        padding-right: 30px;
        box-sizing: border-box;
    }
    #NoticeRule .rule-box .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    #NoticeRule .rule-box .el-form-item.m-b-0{
        width: 100% !important;
        margin-bottom: 0 !important;
    }
    #NoticeRule .rule-box .el-form-item{
        width: 100% !important;
        margin-bottom: 11px !important;
    }
    #NoticeRule .rule-box .el-form-item__label{
        padding: 0 !important;
        color: #2f3a4e !important;
        line-height: 14px !important;
        margin-top: 10px;
        margin-bottom: 5px;
    }
    #NoticeRule .rule-box .el-form-item__content{
        line-height: 34px !important;
    }
    #NoticeRule .search .el-icon-search{
        line-height: 34px !important;
    }
    #NoticeRule .rule-box .el-form-item.m-b-10 {
        margin-bottom: 10px !important;
    }
    #NoticeRule .rule-box .el-input__icon{
        line-height: 34px !important;
    }
    #NoticeRule .search .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    #NoticeRule .weekList .el-checkbox{
        margin-right: 15px;
    }
    #NoticeRule .notice-type-select .el-checkbox{
        margin-right: 15%;
        color: #363636;
    }
    #NoticeRule .remarks textarea{
        width: 100%;
        height: 76px;
        border: 1px solid #dedede;
        resize: none;
        padding:5px;
        box-sizing: border-box;
        line-height: 20px;
        overflow: hidden;
    }
    #NoticeRule .rule-box .el-form-item__content .weekList{
        line-height: 12px !important;
    }
    #NoticeRule .popup .is-current .el-tree-node__content{
        background-color: transparent !important;
    }
    #NoticeRule .tree-box .el-tree-node__content{
        padding-left: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/NoticeRule/NoticeRuleList.vue